export const generateMessageForTelegram = (data, user) => {
  const { city, address, company, website, comments } = data ?? {};
  const { id, email, phone, fio } = user ?? {};
  const title = '&#x2757;Заявка на интеграцию от пользователя:';

  const objectData = [
    { string: 'ID пользователя', value: id },
    { string: 'ФИО', value: fio },
    { string: 'Email', value: email },
    { string: 'Номер телефона', value: phone },
    { string: 'Город', value: city },
    { string: 'Адрес', value: address },
    { string: 'Управляющая компания', value: company },
    { string: 'Сайт УК', value: website },
    { string: 'Комментарии', value: comments },
  ];

  const message = objectData
    .map((data) => {
      if (data.value) {
        return `    ${data.string}: ${data.value}`;
      }
    })
    .filter(Boolean)
    .join(';\n');

  return `${title}\n${message}`;
};
